// @ts-nocheck
import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { isEmpty } from "lodash";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const PoolConfiguration = React.memo((props) => {
  const { poolConfigurationData, isLoading, isFetched } = props;
  const { colors } = useTheme();
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Pools </H9TitleSmall>
        <StyledIconButton colors={colors}>
          <KeyboardArrowRightIcon
            fontSize="medium"
          />
        </StyledIconButton>
      </Box>
      <>
        {isLoading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexGrow={1}
          >
            <CircularProgress
              size={"2rem"}
              sx={{
                color: colors.primary.main,
              }}
            />
          </Box>
        )}
        {isFetched &&
          poolConfigurationData?.length > 0 &&
          poolConfigurationData?.map((pool, index) => (
            <List
              key={index}
              sx={{
                width: "100%",
                backgroundColor: colors.background.accent,
                borderRadius: "1.5rem",
              }}
            >
              <ListItem>
                <ListItemText sx={{ color: colors.text.primary }}>{`Pool ${
                  index + 1
                } :`}</ListItemText>
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="URL"
                  secondary={pool.url}
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: colors.text.primary,
                    },
                    "& .MuiListItemText-secondary": {
                      color: colors.text.muted,
                    },
                  }}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: colors.text.primary,
                    },
                    "& .MuiListItemText-secondary": {
                      color: colors.text.muted,
                    },
                  }}
                  primary="User"
                  secondary={pool.user}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  sx={{
                    "& .MuiListItemText-primary": {
                      color: colors.text.primary,
                    },
                    "& .MuiListItemText-secondary": {
                      color: colors.text.muted,
                    },
                  }}
                  primary="Pass"
                  secondary={pool.pass}
                />
              </ListItem>
            </List>
          ))}
        {isFetched && isEmpty(poolConfigurationData) && (
          <List
            sx={{
              width: "100%",
              backgroundColor: colors.background.paper,
              borderRadius: "1.5rem",
            }}
          >
            <ListItem>
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary": {
                    color: colors.text.primary,
                  },
                  "& .MuiListItemText-secondary": {
                    color: colors.text.muted,
                  },
                }}
                primary="No Pool Configured"
              />
            </ListItem>
          </List>
        )}
      </>
    </Box>
  );
});
